import React, { Component  } from 'react';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { withTranslation } from "react-i18next";
import {
  Col, Container, Row
} from "reactstrap";

import AssetForm from "./components/AssetForm";
import ComponentList from "./components/ComponentList";
import { createOrUpdateAsset } from "../../../redux/actions/assetsManagement";
import { loadAssetTypes } from "../../../redux/actions/entity_types";
import { loadCollections } from "../../../redux/actions/collections";
import _  from "lodash"

export class AssetCreateUpdate extends Component {

  componentDidMount() {
    this.props.loadAssetTypes();
    this.props.loadCollections();
  }

  handleCreate = dataObj => {
    const data = JSON.parse(JSON.stringify(dataObj));


    // console.log({data});
    // return false;

    data.asset_type_id =
      data.asset_type_name && data.asset_type_name.value && data.asset_type_name.value !== undefined
        ? data.asset_type_name.value : data.asset_type_id;

    data.data_status =
      data.data_status && data.data_status.value && data.data_status.value !== undefined
        ? data.data_status.value : data.data_status;

    data.collection_id = _.find(this.props.collections, ['collection_name', data.collection_name])._id

    data.activity_status =
      data.activity_status && data.activity_status.value && data.activity_status.value !== undefined
        ? data.activity_status.value : data.activity_status;

    const detailsObject = {};
    if (data.details && data.details.length > 0) {
      data.details.map( detail => detailsObject[detail.key] = detail.value);
    }
    data.details = detailsObject;

    delete data.formType;

    return this.props.createOrUpdateAsset(data, this.props.history);
  };

  build_type_lists(selectedAsset = {}, asset_types, collections){
    if(selectedAsset && Object.keys(selectedAsset).length > 0) {
      asset_types.filter(asset_type => {
        if(selectedAsset.asset_type_name === asset_type.name) {
          selectedAsset.asset_type_name = {value: asset_type._id, label: asset_type.name};
        }
        return asset_type;
      });

      let newSelectedAsset = JSON.parse(JSON.stringify(selectedAsset));

      if (selectedAsset.data_status){
        newSelectedAsset.data_status = {
          value:selectedAsset.data_status,
          label: selectedAsset.data_status.replace(/_/g,' ')
        };
      }

      if (selectedAsset.activity_status){
        newSelectedAsset.activity_status = {
          value:selectedAsset.activity_status,
          label: selectedAsset.activity_status.replace(/_/g,' ')
        };
      }

      if (newSelectedAsset.formType == "clone"){
        newSelectedAsset._id = null;
        delete newSelectedAsset._id;
      }

      return newSelectedAsset;
    }
    return selectedAsset;
  }

  renderField =
    ({
       input, placeholder, type, meta: { touched, error },
     }) => (
       <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
        <input {...input} placeholder={placeholder} type={type} />
        {touched && error && <span className="form__form-group-error">{error}</span>}
      </div>
  );

  render () {
    const { t, selectedAsset, asset_types, collections } = this.props;
    let newSelectedAsset = this.build_type_lists(selectedAsset, asset_types, collections);

    return (
      <Container>
        <Row>
          <Col md={12}>
            <h3 className="page-title">{t('asset_management.create_update_asset.title')}</h3>
            <h3 className="page-subhead subhead">{t('asset_management.create_update_asset.sub_title')}
            </h3>

            <AssetForm
              form_data={newSelectedAsset}
              onSubmit={this.handleCreate}
              onCancel={() => {
                this.closeForm();
              }}
            />

            {
              newSelectedAsset && newSelectedAsset.formType &&
              newSelectedAsset.formType == "update" &&
              <ComponentList
                history={this.props.history}
                selectedAsset={selectedAsset}
              />
            }

          </Col>
        </Row>
      </Container>
    );
  }
}

AssetCreateUpdate.propTypes = {
  t: PropTypes.func.isRequired,
  createOrUpdateAsset: PropTypes.func.isRequired,
  components: PropTypes.array,
};

function mapStateToProps({
   assetsManagement, component, collections, asset_types
}) {
  return {
    selectedAsset: assetsManagement.selectedAsset,
    components: component.components,
    collections,
    asset_types,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      createOrUpdateAsset,
      loadAssetTypes,
      loadCollections,
    },
    dispatch
  );
}

export default withTranslation('common') (
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(AssetCreateUpdate)
);
